import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import httpClient from "../../utils/httpClient";

interface RequestDetails {
  Page?: number;
  Record?: number;
  Search?: string;
}

interface BMOSku {
  SkuId: string;
  Name: string;
  Description: string;
  StatusName: string;
  StatusCd: string;
  CreatedDtm: string;
  BillingTypeCd: string;
  CostMetricNSR: number | null;
  UpdatedDtm: string;
  CreatedUser: string;
  ValidFrom: string;
  ValidTo: string;
  UpdateCost?: number | null;
  UpdateNSR?: number | null;
  UpdateIndexation?: number | null;
  UpdatePublishDtm?: string | null;
  ProductId?: string | null;
  UpdateCostId?: string | null;
}

interface BMOApprovalList {
  isLoading: boolean;
  data: {
    Page: number;
    Record: number;
    TotalRecord: number;
    TotalPages: number;
    Result: BMOSku[];
  } | null;
  error: string | null;
}

const initialState: BMOApprovalList = {
  isLoading: false,
  data: {
    Page: 1,
    Record: 0,
    TotalRecord: 0,
    TotalPages: 0,
    Result: [],
  },
  error: null,
};

export const fetchBMOApprovalListData = createAsyncThunk<any, RequestDetails>(
  "CTDBBMODataSlice/fetchBMOApprovalListData",
  async (requestDetails, thunkApi) => {
    try {
      const response = await httpClient.post("bmo/product/sku", {
        Page: requestDetails.Page,
        Record: requestDetails.Record,
        Search: requestDetails.Search,
        Action: "approveList",
      });
      if (response.status != 200 || response.data.Status !== "success") {
        if (response.data.Status == "error") {
          return thunkApi.rejectWithValue({
            message: response.data.Message,
          });
        } else {
          return thunkApi.rejectWithValue({
            message: "Failed to get BMO approval list",
          });
        }
      }
      return response.data;
    } catch (error: any) {
      console.log("🚀 ~ error:", error);
      return thunkApi.rejectWithValue({
        message: "Failed to get BMO approval list",
      });
    }
  }
);

const CTDBBMOApprovalListSlice = createSlice({
  name: "CTDBBMOApprovalListSlice",
  initialState,
  reducers: {
    resetBMOApprovalList: (state) => {
      state.isLoading = false;
      state.data = initialState.data;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchBMOApprovalListData.pending, (state) => {
        state.isLoading = true;
        state.error = null;
        state.data = null;
      })
      .addCase(
        fetchBMOApprovalListData.fulfilled,
        (state, action: PayloadAction<any>) => {
          state.isLoading = false;
          state.data = action.payload.Data;
          state.error = null;
        }
      )
      .addCase(
        fetchBMOApprovalListData.rejected,
        (state, action: PayloadAction<any>) => {
          state.isLoading = false;
          state.error =
            action.payload?.message || "Failed to get BMO approval list";
        }
      );
  },
});

export const { resetBMOApprovalList } = CTDBBMOApprovalListSlice.actions;

export default CTDBBMOApprovalListSlice.reducer;
